class AnimateContent extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['content']
  }

  connectedCallback () {
    /* eslint-disable-next-line no-undef */
    if (Shopify.designMode) return

    super.connectedCallback()

    this.isTicking = false

    if (this.dataset.runInstant === 'true') {
      setTimeout(() => {
        this.setAttribute('animate', '')
      }, 500)
    } else {
      // eslint-disable-next-line compat/compat
      this.observer = new IntersectionObserver(this.onEntry.bind(this), {
        threshold: 0.2,
      })

      this.observer.observe(this)
    }
  }

  setupListeners () {
    super.setupListeners()

    if (this.hasAttribute('animate-opacity-on-scroll')) {
      this.requestTick = this.requestTick.bind(this)
      this.updateOpacity = this.updateOpacity.bind(this)

      document.addEventListener('scroll', this.handleScroll.bind(this), {
        passive: true,
      })
    }
  }

  onEntry ([entry], observer) {
    if (!entry.isIntersecting) return

    this.setAttribute('animate', '')

    observer.unobserve(this)
  }

  handleScroll () {
    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateOpacity)

    this.isTicking = true
  }

  updateOpacity () {
    this.isTicking = false

    const viewportHeight = window.innerHeight
    const distanceFromTop = Math.round(
      this.getBoundingClientRect().top - this.clientHeight,
    )

    this.opacity = (100 - (distanceFromTop / viewportHeight) * 100) / 100

    this.style.setProperty('--Opacity', `${this.opacity}`)
  }

  set opacity (value) {
    this._opacity = value < 0 ? 0 : value > 1 ? 1 : value
  }

  get opacity () {
    return this._opacity
  }
}

if (!customElements.get('animate-content')) {
  customElements.define('animate-content', AnimateContent)
}
